"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Dialog_1 = require("../Dialog");
var Button_1 = __importDefault(require("../Button"));
var __1 = require("..");
exports.default = react_1.forwardRef(function SimpleDialog(_a, ref) {
    var _b;
    var title = _a.title, text = _a.text, children = _a.children, onClose = _a.onClose, open = _a.open, actionsGridProps = _a.actionsGridProps, _c = _a.hideActions, hideActions = _c === void 0 ? false : _c, _d = _a.actions, actions = _d === void 0 ? [] : _d, dialogProps = __rest(_a, ["title", "text", "children", "onClose", "open", "actionsGridProps", "hideActions", "actions"]);
    var _e = react_1.useState(open), isOpen = _e[0], setIsOpen = _e[1];
    react_1.useEffect(function () { return setIsOpen(open); }, [open]);
    if (onClose === undefined) {
        onClose = function () { return setIsOpen(false); };
    }
    if (actions.length === 0) {
        actions = [
            {
                title: 'Ok',
                onClick: onClose,
            },
        ];
    }
    var actionsGridContainerProps = __assign({ justify: 'flex-end', alignItems: 'center', spacing: 2 }, actionsGridProps);
    return (jsx_runtime_1.jsxs(Dialog_1.Dialog, __assign({ open: isOpen, onClose: onClose }, dialogProps, { ref: ref }, { children: [Boolean(title) && jsx_runtime_1.jsx(Dialog_1.DialogTitle, { children: title }, void 0),
            (Boolean(text) || Boolean(children)) && (jsx_runtime_1.jsxs(Dialog_1.DialogContent, { children: [text !== null && jsx_runtime_1.jsx(Dialog_1.DialogContentText, { children: text }, void 0), children] }, void 0)),
            hideActions === false && (jsx_runtime_1.jsx(__1.Box, __assign({ padding: (_b = actionsGridContainerProps.spacing) !== null && _b !== void 0 ? _b : 2 }, { children: jsx_runtime_1.jsx(__1.Grid, __assign({ container: true }, actionsGridContainerProps, { children: actions.map(function (action, index) {
                        if ('title' in action) {
                            var title_1 = action.title, destructive = action.destructive, variant = action.variant, onClick_1 = action.onClick, disabled = action.disabled;
                            return (jsx_runtime_1.jsx(__1.Grid, __assign({ item: true }, { children: jsx_runtime_1.jsx(Button_1.default, { color: destructive ? 'secondary' : 'primary', variant: variant, onClick: function () {
                                        onClick_1 === null || onClick_1 === void 0 ? void 0 : onClick_1();
                                        onClose === null || onClose === void 0 ? void 0 : onClose({}, 'actionClicked');
                                    }, label: title_1, disabled: disabled }, void 0) }), title_1 + index));
                        }
                        else {
                            return (jsx_runtime_1.jsx(__1.Grid, __assign({ item: true }, { children: action }), title + "-" + index));
                        }
                    }) }), void 0) }), void 0))] }), void 0));
});
//# sourceMappingURL=SimpleDialog.js.map